import { createSelector } from 'reselect';

export const selectPeriodsSlice = state => state.periods;

export const selectPeriods = createSelector(
  selectPeriodsSlice,
  slice => slice.periods
);
export const periodsLoaded = createSelector(
  selectPeriodsSlice,
  slice => slice.periodsLoaded
);
export const selectActivePeriod = createSelector(
  selectPeriodsSlice,
  slice => slice.activePeriod
);
export const periodsMeta = createSelector(
  selectPeriodsSlice,
  slice => slice.meta
);

export const periodCreating = createSelector(
  selectPeriodsSlice,
  slice => slice.isCreating
);
export const periodUpdating = createSelector(
  selectPeriodsSlice,
  slice => slice.isUpdating
);
export const periodDeleting = createSelector(
  selectPeriodsSlice,
  slice => slice.isDeleting
);
export const periodFilters = createSelector(
  selectPeriodsSlice,
  slice => slice.filters
);
export const periodEvent = createSelector(
  selectPeriodsSlice,
  slice => slice.eventId
);

export const selectCalendarPeriods = createSelector(
  selectPeriodsSlice,
  slice => {
    return slice.periods.map(period => {
      return {
        title: period.name,
        start: period.startsAt,
        end: period.endsAt,
        tmlId: period.id,
        period: period,
        color: period.color
      };
    });
  }
);
